export const getUniqueId = () => `hw-${Math.round(Math.random() * 1e5)}`;
